/** Helpers for modules that keep per-state words (the StateWords convention in types.ts). */
import { stateOrDefault } from "./index.ts";
import type { UsState } from "./types.ts";

/** Pick a module's words for a state (absent or unsupported = Utah's, the default). */
export const wordsFor = <W>(table: Record<UsState, W>, state?: string | null): W => table[stateOrDefault(state)];
/** Join citation parts with "; ", leaving out the ones a state has no verified text for (null). */
export const cite = (...parts: (string | null | undefined)[]): string => parts.filter((p): p is string => !!p).join("; ");
/** Build a catalog once per state, from that state's words (the per-state cache of the `xxxFor(state)` functions). Absent or unsupported state = Utah's. */
export const perState = <T>(build: (state: UsState) => T): ((state?: string | null) => T) => {
  const cache = new Map<UsState, T>();
  return (state) => {
    const st = stateOrDefault(state);
    if (!cache.has(st)) cache.set(st, build(st));
    return cache.get(st) as T;
  };
};
